import React, { ComponentType } from 'react';
import { Route, Redirect } from 'react-router';
import { useAuthStatus, useSessionStoreLoading } from '../../store/hooks';

interface IProps {
  path: string;
  Component: ComponentType<any>;
}

const AuthRoute: React.FC<IProps> = ({ path, Component }) => {
  const isLoading = useSessionStoreLoading();
  const isLoggedIn = useAuthStatus();

  if (!isLoggedIn && isLoading) {
    return null;
  }

  const renderRoute = (props: any) => {
    if (isLoggedIn) {
      return <Component {...props} />;
    }

    return <Redirect to={'/auth'} />;
  };

  return <Route path={path} render={renderRoute} />;
};

export default AuthRoute;
